
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-slate-100 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl md:text-7xl font-bold mb-12" style={{ color: 'rgb(17, 50, 99)' }}>
          成都蜀锐报销系统
        </h1>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <button
            onClick={() => navigate('/expense')}
            className="px-12 py-6 text-white rounded-xl font-semibold text-xl hover:opacity-90 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            style={{ backgroundColor: 'rgb(17, 50, 99)' }}
          >
            <i className="ri-file-add-line mr-3"></i>
            开始报销
          </button>
          <button
            onClick={() => navigate('/admin')}
            className="px-12 py-6 border-2 text-xl rounded-xl font-semibold hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap"
            style={{ borderColor: 'rgb(17, 50, 99)', color: 'rgb(17, 50, 99)' }}
          >
            <i className="ri-admin-line mr-3"></i>
            管理后台
          </button>
        </div>
      </div>
    </div>
  );
}